import { createSlice } from "@reduxjs/toolkit";
import { colourToColourObjectType } from "../../utils/ColourGenerators/ColourToColourObjectType";

export interface brandColour {
  name: string | null;
  value: {
    rgb: {
      r: number;
      g: number;
      b: number;
    };
    hex: string;
    hsl: {
      h: number;
      s: number;
      l: number;
    };
  };
  category: any;
  associateColours: any;
  prevColours?: {
    rgb: { r: number; g: number; b: number };
    hex: string;
    hsl: { h: number; s: number; l: number };
  }[];
}

interface brandColoursType {
  selectedColour: brandColour | null;
  brandColours: brandColour[];
  prevColours?: brandColour[];
}

const initialManualColourState: brandColoursType = {
  selectedColour: null,
  brandColours: [
    {
      ...colourToColourObjectType("#0A2C37", "Source Colour 0"),
      prevColours: [],
    }
  ],
};
export const brandColourSlice = createSlice({
  name: "brandColours",
  initialState: initialManualColourState,
  reducers: {
    addToBrandColour: (state, action) => {
      //@ts-ignore
      const newObj = colourToColourObjectType(
        action.payload,
        `Source Colour ${state.brandColours?.length + 1}`
      );
      state.brandColours?.push(newObj);
    },
    removeFromBrandColours: (state, action) => {
      //@ts-ignore
      const newState: brandColour[] = [];
      state.brandColours.map((e) => {
        if (e.name !== action.payload.name) newState.push(e);
      });
      state.brandColours = newState as brandColour[];
    },
    setBrandColours: (state, action) => {
      state.brandColours = action.payload;
    },
    editBrandColour: (state, action) => {
      state.brandColours.forEach((element: brandColour, index: number) => {
        if (element.name === action.payload.name) {
          state.brandColours[index].name = action.payload.name;
          state.brandColours[index].category = action.payload.category;
          state.brandColours[index].value = action.payload.value;
          state.brandColours[index].associateColours =
            action.payload.associateColours;
          if (state.brandColours[index].prevColours?.length < 20) {
            state.brandColours[index].prevColours?.push(
              action.payload.prevColours
            );
          } else {
            state.brandColours[index].prevColours = [];
            state.brandColours[index].prevColours?.push(
              action.payload.prevColours
            );
          }

          state.brandColours[index].associateColours = [];
        }
      });
    },
    setBrandSelectedColour: (state, action) => {
      state.selectedColour = action.payload;
    },
    removeBrandSelectedColour: (state) => {
      state.selectedColour = null;
    },
    addAssociateColour: (state, action) => {
      state.brandColours.forEach((element: brandColour, index: number) => {
        if (element.name === action.payload.name) {
          state.brandColours[index].associateColours =
            action.payload.associateColours;
        }
      });
    },
    undoClickHandler: (state) => {
      state.brandColours.forEach((element: brandColour, index: number) => {
        if (element.name === state.selectedColour?.name) {
          if (state.brandColours[index].prevColours?.length > 1) {
            state.brandColours[index].value =
              state.brandColours[index].prevColours[
                state.brandColours[index].prevColours.length - 2
              ].value;

            state.brandColours[index].prevColours?.pop();
            state.selectedColour = state.brandColours[index];
          }
        }
      });
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addToBrandColour,
  removeFromBrandColours,
  setBrandColours,
  editBrandColour,
  setBrandSelectedColour,
  removeBrandSelectedColour,
  addAssociateColour,
  undoClickHandler,
} = brandColourSlice.actions;

export default brandColourSlice.reducer;
